import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Button, Grid, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { getCar } from 'redux/actions/UserCar';
import { patchUpdateVehicle, deleteVehicle } from 'redux/actions/UserVehicle';
import { getOnBoardCompliance } from 'redux/actions/UserCompliance';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import MoreDetails from 'components/moreDetails/MoreDetails';
import { vehicleDialogData } from 'pages/vendor/VendorBreadCrumbData';
import { subVendorVechileMatrix } from 'pages/subVendors/vechileSubVendor/SubVendorVechileData';
import MatrixDriverVendor from './MatrixDriverVendor';
import AminitiesVehicle from './AminitiesVehicle';
import noVehicleFound from 'assets/images/NoCarImg.svg';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CommonDialog from 'components/commonDialog/CommonDialog';

function VehicleInfo(props) {
  const dispatch = useDispatch();
  const { vehicleInfo, vehicleImage } = props;
  const { state } = useLocation();
  const vehicleId = state?.vehicleId;
  const driverName = state?.id;
  const VehicelName = state?.name;
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  const [deleteDialog, setDeleteDialog] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getCar());
  }, []);

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const editVehicle = () => {
    setOpen(true);
    const updatedVehicleData = {
      ...vehicleData,
      fireExtinguisher: vehicleData?.fireExtinguisher?.toString(),
      firstAid: vehicleData?.firstAid?.toString(),
      stepney: vehicleData?.stepney?.toString(),
    };
    setDefaultValue(updatedVehicleData);
  };

  const editComplianceVehicle = () => {
    setOpen(true);
    const profileData = {
      vehicleId: vehicleId || props?.driverVehicleId,
      type: 'vehicleRegistration',
    };
    setShowOtherComponent(true);
    dispatch(getOnBoardCompliance(profileData));
  };

  const onDialog = (data, code) => {
    const vehicleData = {
      ...data,
      carType: 'COC',
      seating: parseInt(data?.seating),
      id: vehicleId || props?.driverVehicleId || data.id,
      type: 'driver',
      avtar: selectedImage,
    };
    let formData = new FormData();
    Object.keys(vehicleData).map((val) => {
      formData.append(val, vehicleData[val]);
    });
    dispatch(patchUpdateVehicle(formData));
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setShowOtherComponent(false);
  };

  const vehicleImages = vehicleImage?.filter(
    (val) => val.attributeType === 'Multi-Image'
  );

   const onDeleteVehicle = () => {
    console.log(props.filterData);
    const payload = {
      vehicleId: vehicleId || props?.driverVehicleId,
      carType: props?.carType || "COC",
      filterData: props?.filterData,
    };
    dispatch(deleteVehicle(payload));
    setDeleteDialog(false);
    navigate(-1);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className="minHeight370"
      >
        <Grid item md={7.4} className="p20 borderStyle">
          <div className="justifyBetween">
            <Typography className="colorPrimary font18 fw600">
              Vehicle Info
            </Typography>
            <div style={{ display: "flex", gap: "15px" }}>
            {props?.editButton && 
            (<Button
              variant="contained"
              className="vendorEditBtn"
              onClick={() => editVehicle()}
            >
              <span>
                <EditOutlinedIcon />
              </span>
            </Button>)}
            {props?.carType !== "DOC" && (
              <Button
                sx={{ minWidth: "20px" }}
                variant="contained"
                className="DriverandvehicledeleteBtn"
                onClick={() => setDeleteDialog(true)}
              >
                <DeleteOutlineIcon />
              </Button>
              )}
            </div>
          </div>
          <Grid item container direction="row" justifyContent="flex-start">
            {vehicleInfo?.map((ele, idx) => (
              <Grid
                item
                md={4}
                sm={6}
                xs={12}
                className="p20 dashedBorderGrey"
                key={ele.body}
              >
                <Grid item className="mb20">
                  <spam className="colorGrey font18 fontNormal">
                    {ele?.title}
                  </spam> <br/>
                  <span className="font16 fontNormal">{ele?.body}</span>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item md={4.4} className="p20 borderStyle">
          <div className="justifyBetween">
            <Typography className="font18 fw600 paddingTop5 marginBottom7">
              {vehicleInfo?.[0]?.body || ''}
            </Typography>
          </div>
          {vehicleImages?.length === 0 ? (
            <div className="justifyCenter height100">
              <img src={noVehicleFound} alt="noVehicleFound" />
            </div>
          ) : (
            <>
              {vehicleImages?.length > 1 ? (
                <Carousel className="paddinginline30block40 vehicleCarousel">
                  {vehicleImages.map((ele, idx) => (
                    <div key={ele.complianceFile?.url}>
                      <img
                        src={ele.complianceFile?.url}
                        className="height122 imageRendering"
                        alt="vehicelImage"
                      />
                    </div>
                  ))}
                </Carousel>
              ) : (
                vehicleImages?.length > 0 && (
                  <div key={vehicleImages[0].complianceFile?.url}>
                    <img
                      src={vehicleImages[0]?.complianceFile?.url}
                      className="height235 width100 backgroundPrimary"
                      alt="vehicelImage"
                    />
                  </div>
                )
              )}
            </>
          )}
        </Grid>
      </Grid>

      <Grid className="p20 borderStyle mt30">
        <Typography className="colorPrimary font18 fw600">Amenities</Typography>
        <AminitiesVehicle />
      </Grid>

      {props?.complianceShow && (
        <div className="borderStyle marginBlock20 paddingTop10 p20">
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <Typography className="colorPrimary font16 fw600">
                Vehicle Compliance
              </Typography>
            </Grid>
            {props?.editButton && <Grid item>
              <Button
                variant="contained"
                className="vendorEditBtn"
                onClick={() => editComplianceVehicle()}
              >
                <span>
                  <EditOutlinedIcon />
                </span>
              </Button>
            </Grid>}
          </Grid>
          <MoreDetails details={props?.vehicleMoreData} />
        </div>
      )}
      {props?.complianceShow && (
        <div className="padding20">
          {' '}
          <MatrixDriverVendor
            matrix={subVendorVechileMatrix(props?.vehicleMatrixData)}
          />{' '}
        </div>
      )}

      
      {/* Delete Confirmation Dialog */}
      {deleteDialog && (
        <CommonDialog
          open={deleteDialog}
          handleClose={() => setDeleteDialog(false)}
          selectType="delete"
          typeOfDialog="Vehicle"
          text="Are you sure you want to delete this vehicle? This cannot be undone."
          onConfirmDialog={onDeleteVehicle}
        />
      )}

      {open ? (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={vehicleDialogData(carOption)}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'edit'}
          type={'Edit ' + 'Vehicle' + ' '}
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="vehicle"
          vehicleId={vehicleId || props?.driverVehicleId}
        />
      ) : null}
    </div>
  );
}

export default VehicleInfo;
